/* ============================================================
   VALOTERNA — Polish (shopweit, leise)
   Datei: assets/valoterna-polish.js
   Eingebunden in layout/theme.liquid direkt nach global.js.
   Fasst keine Dawn-Datei an; hört nur zu und ergänzt.
   ============================================================ */
(() => {
  if (window.__vlPolish) return;
  window.__vlPolish = true;

  const RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  const de = (document.documentElement.lang || 'de').toLowerCase().startsWith('de');
  const T = de
    ? { added: 'Im Warenkorb', more: 'ansehen', go: 'Im Warenkorb – zum Warenkorb' }
    : { added: 'In your cart', more: 'view', go: 'In your cart – go to cart' };
  const SPRING = 'cubic-bezier(.34,1.56,.64,1)';
  const canScale = !!(window.CSS && CSS.supports('scale', '1'));
  const cartUrl = (window.routes && window.routes.cart_url) || '/cart';

  /* =========================================================
     1. Druck & Loslassen für alle Buttons
     Über die eigene CSS-Eigenschaft "scale" per Web Animations:
     überschreibt weder Dawns noch eure Transitions oder Transforms.
     ========================================================= */
  const PRESS = '.button, .val-btn, .vr-btn, .shopify-payment-button__button';
  let pressed = null;

  const pressDown = (e) => {
    if (e.button > 0 || RM.matches || !canScale) return;
    const b = e.target.closest(PRESS);
    if (!b || b.disabled || b.getAttribute('aria-disabled') === 'true') return;
    if (b.closest('[data-vl-press], .vl-cart, .vl-cn')) return; // Warenkorb & Pop-up haben eigene Logik
    pressed = b;
    b._vlpAnim?.cancel();
    b._vlpAnim = b.animate([{ scale: '1' }, { scale: '0.975' }], { duration: 130, easing: 'ease-out', fill: 'forwards' });
  };
  const release = () => {
    const b = pressed;
    if (!b) return;
    pressed = null;
    const from = getComputedStyle(b).scale;
    b._vlpAnim?.cancel();
    b._vlpAnim = b.animate([{ scale: !from || from === 'none' ? '0.975' : from }, { scale: '1' }], {
      duration: 520,
      easing: SPRING,
    });
  };
  document.addEventListener('pointerdown', pressDown, true);
  document.addEventListener('pointerup', release, true);
  document.addEventListener('pointercancel', release, true);
  document.addEventListener(
    'pointerout',
    (e) => {
      if (pressed && !pressed.contains(e.relatedTarget)) release(); // weggezogen: zurück, keine Aktion
    },
    true
  );

  /* =========================================================
     2. „In den Warenkorb“
     Ablauf: Klick → Text dimmt, Goldlinie läuft → Erfolg: Haken
     zeichnet sich, „Im Warenkorb“ → danach dauerhaft
     „✓ Im Warenkorb · ansehen →“ (Unikat: ein zweites Hinzufügen
     wäre nur ein Fehler) → Klick führt zum Warenkorb.
     ========================================================= */
  const ATC = '.product-form__submit, .quick-add__submit';
  const inCart = new Set();
  let addedOk = false;
  let busyBtn = null;

  const variantOf = (btn) => btn.form?.querySelector('[name="id"]')?.value || '';

  const setInCart = (btn, on) => {
    if (!btn.dataset.vlp) return;
    btn.classList.toggle('vlp-in-cart', on);
    if (on) btn.setAttribute('aria-label', T.go);
    else btn.removeAttribute('aria-label');
  };

  const syncButtons = () => {
    document.querySelectorAll(`${ATC}[data-vlp]`).forEach((btn) => {
      if (btn.classList.contains('vlp-busy') || btn.classList.contains('vlp-added')) return;
      setInCart(btn, inCart.has(variantOf(btn)));
    });
  };

  const refreshFromCart = async () => {
    if (!document.querySelector(ATC)) return;
    try {
      const res = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      inCart.clear();
      (cart.items || []).forEach((i) => inCart.add(String(i.variant_id)));
      syncButtons();
    } catch (e) {
      /* still: Button bleibt einfach normal */
    }
  };

  const atcObserver = new MutationObserver((list) => {
    list.forEach((m) => {
      const b = m.target;
      const loading = b.classList.contains('loading');
      if (loading === b._vlpLoading) return; // nur echte Wechsel von Dawns "loading"
      b._vlpLoading = loading;

      if (loading) {
        addedOk = false;
        busyBtn = b;
        clearTimeout(b._vlpT);
        b.classList.remove('vlp-added', 'vlp-in-cart');
        b.classList.add('vlp-busy');
        return;
      }

      b.classList.remove('vlp-busy');
      if (addedOk && busyBtn === b) {
        addedOk = false;
        inCart.add(variantOf(b));
        b.classList.add('vlp-added');
        b._vlpT = setTimeout(() => {
          b.classList.remove('vlp-added');
          setInCart(b, true);
        }, 1900);
      } else {
        // Fehler (z. B. schon im Warenkorb): echten Stand nachladen
        refreshFromCart();
      }
    });
  });

  const enhanceButtons = () => {
    document.querySelectorAll(ATC).forEach((btn) => {
      if (btn.dataset.vlp || btn.disabled || btn.closest('modal-opener')) return; // "Optionen wählen" & ausverkauft bleiben unberührt
      btn.dataset.vlp = '1';
      btn.querySelector(':scope > span')?.classList.add('vlp-atc-label');
      btn.insertAdjacentHTML(
        'beforeend',
        '<span class="vlp-atc-done" aria-hidden="true">' +
          '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>' +
          `<span>${T.added}</span>` +
          `<span class="vlp-atc-more"><span class="vlp-atc-dot">·</span>${T.more}` +
          '<svg class="vlp-atc-arrow" viewBox="0 0 24 24"><path d="M5 12h14M13 6l6 6-6 6"/></svg></span>' +
          '</span>' +
          '<span class="vlp-atc-bar" aria-hidden="true"></span>'
      );
      btn._vlpLoading = btn.classList.contains('loading');
      atcObserver.observe(btn, { attributes: true, attributeFilter: ['class'] });
      setInCart(btn, inCart.has(variantOf(btn)));
    });
  };

  // Liegt der Stein schon im Warenkorb, führt der Button dorthin, statt erneut hinzuzufügen
  document.addEventListener(
    'click',
    (e) => {
      const b = e.target.closest('.vlp-in-cart');
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = cartUrl;
    },
    true
  );

  /* =========================================================
     3. Header-Warenkorb pulsiert einmal golden
     ========================================================= */
  const pulseCart = () => {
    if (RM.matches) return;
    // kurz warten, bis cart-notification.js die Zahl im Header ersetzt hat
    setTimeout(() => {
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon) return;
      if (canScale) {
        icon.animate([{ scale: '1' }, { scale: '1.14' }, { scale: '1' }], { duration: 620, easing: SPRING });
        icon
          .querySelector('.cart-count-bubble')
          ?.animate(
            [{ scale: '0.4', opacity: 0 }, { scale: '1.15', opacity: 1, offset: 0.6 }, { scale: '1', opacity: 1 }],
            { duration: 620, easing: 'ease-out' }
          );
      }
      icon.classList.remove('vlp-ring');
      void icon.offsetWidth;
      icon.classList.add('vlp-ring');
    }, 160);
  };

  const hookCartEvents = () => {
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      addedOk = true; // Dawn meldet den Erfolg, bevor es "loading" entfernt
      pulseCart();
    });
  };

  /* =========================================================
     4. Goldwinkel auf Edelstein-Karten
     ========================================================= */
  const addCorners = () => {
    document
      .querySelectorAll('.product-card-wrapper .card__inner, .collection-card-wrapper .card__inner')
      .forEach((el) => {
        if (el.querySelector(':scope > .vlp-corner')) return;
        el.insertAdjacentHTML(
          'beforeend',
          '<span class="vlp-corner vlp-corner--a" aria-hidden="true"></span><span class="vlp-corner vlp-corner--b" aria-hidden="true"></span>'
        );
      });
  };

  /* =========================================================
     Start + nachgeladene Inhalte (Filter, Quick-Add, Varianten)
     ========================================================= */
  const enhanceAll = () => {
    enhanceButtons();
    addCorners();
  };

  const start = () => {
    hookCartEvents();
    enhanceAll();
    refreshFromCart();
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(enhanceAll, 80);
    }).observe(document.body, { childList: true, subtree: true });
  };

  // Zurück-Button (Seite aus dem Browser-Cache): Stand neu prüfen
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) refreshFromCart();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
